module.exports = __webpack_public_path__ + "static/media/plus-icon.05ae6a81.svg";